export default "__VITE_ASSET__cd469097__"